import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
  },

  testOutcomes: {
    display: 'flex',
    flex: '1',
  },

  list: {
    position: 'relative',
    width: '100%',
  },

  listContent: {
    position: 'absolute',
    top: 0,
    right: 'auto',
    bottom: 0,
    left: 0,
    padding: '.3rem',
    overflowY: 'auto',
    overflowX: 'hidden',
  },

  stackedList: {
    width: '22.2rem',
    marginRight: '1.5rem',
  },

  detail: {
    display: 'flex',
    flexFlow: 'column',
    flex: '1',
  },

  actions: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '.6rem',
    backgroundColor: '#ddd',
  },

  switchAnnotation: {
    '& button[class^="btn-"]:first-child': {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
    },

    '& button[class^="btn-"]:last-child': {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      marginLeft: 0,
      borderLeft: 0,
    },
  },

  annotator: {
    flex: 1,
    position: 'relative',
  },
})

export default useStyles
